// src/layouts/auth/AuthLayout.js
// Layout specifically for authentication pages (Sign In, Sign Up, etc.)

import React from 'react';
import { Outlet } from 'react-router-dom'; // Used to render nested routes
import { Flex, Box, useColorModeValue } from '@chakra-ui/react';
// You can potentially reuse parts of the DefaultAuth placeholder or create a simpler layout
// For simplicity, this is a very basic centered layout.
// import DefaultAuth from './Default'; // Or use the more complex one if implemented

function AuthLayout() {
    const bgColor = useColorModeValue("gray.100", "gray.900");
    return (
        <Flex
            minH="100vh"
            align="center"
            justify="center"
            bg={bgColor}
            p={4}
        >
            {/* Outlet renders the specific auth page component (e.g., SignIn) */}
            <Outlet />
        </Flex>
    );
}

export default AuthLayout;
